import { User } from 'lucide-react';
import { Node } from '@xyflow/react';
import { EventCatalogResource } from '../../types';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

type ActorNodeData = EventCatalogResource & {
  name: string;
  summary: string;
};

export type ActorNode = Node<ActorNodeData, 'actor'>;

export default function Actor(props: ActorNode) {
  const { name, summary } = props?.data;

  const mode = props?.data?.mode || 'simple';

  const nodeLabel = 'Actor';

  return (
    <div
      className={classNames(
        'w-full rounded-md border flex justify-start bg-white text-black min-h-[100px]',
        props?.selected ? 'border-yellow-600 ring-2 ring-yellow-500 shadow-lg' : 'border-yellow-400'
      )}
    >
      <div
        className={`bg-gradient-to-b from-yellow-500 to-yellow-700 relative flex items-center w-5 justify-center rounded-l-sm text-yellow-100 border-r-[1px] border-yellow-500`}
      >
        <User className="w-4 h-4 opacity-90 text-white absolute top-1" />
        {mode === 'full' && (
          <span
            className={'w-1/2 text-center absolute bottom-1 text-[8px] text-white font-bold uppercase tracking-[3px]'}
            style={{ transform: 'rotate(-90deg)' }}
          >
            {nodeLabel}
          </span>
        )}
      </div>
      <div className="p-1 min-w-60 max-w-[min-content]">
        <div className={classNames(mode === 'full' ? `border-b border-gray-200` : '')}>
          <span className="text-xs font-bold block pt-0.5 pb-0.5">{name}</span>
          {mode === 'simple' && (
            <div className="flex justify-between">
              <span className="text-[10px] text-gray-500 font-light block pt-0.5 pb-0.5">{nodeLabel}</span>
            </div>
          )}
        </div>
        {mode === 'full' && (
          <div className="divide-y divide-gray-200">
            <div className="leading-3 py-1">
              <div
                className="text-[8px] font-light overflow-hidden"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
                title={summary}
              >
                {summary}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
